
import { InteriorLuna } from "GameObjects/GameInterior/InteriorLuna";

// import "vendor/pixi-spine-debug";

export class InteriorLunaGiveQuest extends InteriorLuna {

    protected left: number = 175;
    protected bottom: number = 0;

    public Instructs() {
        this.playAnimation("instructs");
    }

    public StopInstructing() {
        const track = this.spine.state.setAnimation(0, "blink", false);
        track.trackTime = track.animationEnd;
    }

}
